import { Button } from '@/components/ui/button';
import { Phone, PhoneOff } from 'lucide-react';

interface IncomingCallBannerProps {
  from: string;
  onAccept: () => void;
  onReject: () => void;
}

export function IncomingCallBanner({ from, onAccept, onReject }: IncomingCallBannerProps) {
  return (
    <div className="fixed top-4 right-4 z-30 w-80 bg-background border rounded-lg shadow-xl p-4 animate-in slide-in-from-top-2">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
          <Phone className="h-5 w-5 text-green-600 animate-pulse" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">Incoming Call</p>
          <p className="text-sm text-muted-foreground font-mono truncate">{from}</p>
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        <Button className="flex-1 bg-green-600 hover:bg-green-700 text-white" onClick={onAccept}>
          <Phone className="h-4 w-4 mr-1" />
          Accept
        </Button>
        <Button variant="destructive" className="flex-1" onClick={onReject}>
          <PhoneOff className="h-4 w-4 mr-1" />
          Decline
        </Button>
      </div>
    </div>
  );
}
